export default __webpack_public_path__ + "static/equipment-main-b9b6338fa70a0d01861499439cddfe1b.jpg";